import {openPanelInModal} from "@Components/modal-container/modal-container-reducer";
import {MODALS_IDS} from "@Components/modal-container";
import type {StylesInputModalProps} from "@Modals/styles-input-modal/styles-input-modal.types";

export const openStylesInputModal = (props: StylesInputModalProps): void => {
    window.PMW.redux.store.dispatch(
        openPanelInModal({
            modalId: MODALS_IDS.STYLES_INPUT_MODAL,
            panelProps: props,
        })
    );
}